// src/components/Checkout/Checkout.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import { useCart } from "@/hooks/useCart";
import { useCheckoutForm } from "@/hooks/useCheckoutForm";
import { useOrderSubmit } from "@/hooks/useOrderSubmit";
import Nav from "@/components/Header/Nav/Nav";
import { CheckoutForm } from "./CheckoutForm";
import { CartItem } from "./CartItem";
import { CartSummary } from "./CartSummary";
import styles from "./Checkout.module.scss";

const Checkout: React.FC = () => {
  const { t } = useTranslation("common");
  const { cart } = useCart();
  const formProps = useCheckoutForm();
  const { loading, submitOrder } = useOrderSubmit();

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Перевіряємо валідність форми
    if (!formProps.validateForm()) {
      return;
    }

    // Отримуємо кнопку, яка була натиснута
    const button = (e.nativeEvent as SubmitEvent)
      .submitter as HTMLButtonElement;

    const isFeedback = button?.name === "feedback";
    const formData = formProps.getFormData();

    // Відправляємо замовлення
    const success = await submitOrder(formData, isFeedback);

    // Якщо успішно - очищаємо форму
    if (success) {
      formProps.resetForm();
    }
  };

  return (
    <>
      <Nav />
      <div className={`pageSection ${styles.pageSection}`}>
        <CheckoutForm
          {...formProps}
          onSubmit={handleFormSubmit}
          loading={loading}
        />

        <div className={styles.cartBlock}>
          {cart.length === 0 ? (
            <p>{t("cart.empty")}</p>
          ) : (
            <ul>
              {cart.map((item) => (
                <CartItem key={`${item.goid}-${item.typeorder}`} item={item} />
              ))}
              <CartSummary cart={cart} />
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

export default Checkout;
